import styled from 'styled-components'

export const Form = styled.form``;

export const ErrorMessage = styled.div`
  margin-top: 3px;
  color: ${(props) => props.theme.colors.redDanger};
`;
